if (!customElements.get('flip-cards')) {
  customElements.define(
    'flip-cards',
    class FlipCards extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      // Hover mode flips with CSS on devices that can hover; everywhere else (touch, or click mode) a tap toggles.
      get flipsOnTap() {
        return this.dataset.trigger === 'click' || !window.matchMedia('(hover: hover)').matches;
      }

      toggle(card) {
        const flipped = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', String(flipped));
      }

      onClick = (event) => {
        const card = event.target.closest('.flc-card:not(.flc-card--static)');
        if (!card || !this.contains(card) || !this.flipsOnTap) return;
        this.toggle(card);
      };

      onKeydown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('.flc-card:not(.flc-card--static)');
        if (!card || event.target !== card) return;
        event.preventDefault();
        this.toggle(card);
      };
    }
  );
}
